export const getBulkUpdatePayload = acceptedItems => {
  return acceptedItems.map(item => {
    const payload = { id: item.id }

    if (item.acceptedHs) {
      payload.hs_code = item.proposed_hs_code
    }

    if (item.acceptedHts) {
      payload.hts_code = item.proposed_hts_code
    }

    return payload
  })
}
